import styles from "../styles/TooltipCVV.module.scss";
import { toAbsoluteUrl } from "../../_metronic";

export default function TooltipCVV() {
  return (
    <div className={styles.container}>
      <p className="color-gray-1" style={{ fontSize: 14 }}>
        O código de segurança (CVV) são os últimos 3 dígitos localizados no verso do cartão de crédito.
      </p>
      <div className={styles.icone}>
        <img alt="helper-cvv" src={toAbsoluteUrl("/images/helper-cvv.png")} style={{ }} />
      </div>
    </div>
  );
}
